import { default as Honeybadger } from '@honeybadger-io/js';
import { assertNever } from '@kofno/piper';
import { CurrentUserStore } from '../../CurrentUserStore';
import { State } from '../../CurrentUserStore/Types';
import ReactionComponent, { RCProps } from '../../ReactionComponent';

const setCurrentHoneybadgerUser = (user_id: number): void => {
  Honeybadger.setContext({ user_id });
};

const clearCurrentHoneybadgerUser = (): void => {
  Honeybadger.setContext({ user_id: null });
};

interface Props extends RCProps<CurrentUserStore> {}

class CurrentHoneybadgerUserReactions extends ReactionComponent<CurrentUserStore, State, Props> {
  tester = () => this.props.store.currentUserState;

  effect = (state: State) => {
    switch (state.kind) {
      case 'identified':
      case 'logging-out':
        setCurrentHoneybadgerUser(state.currentUserResource.payload.id);
        break;
      case 'anonymous':
      case 'unauthorized':
      case 'errored':
        clearCurrentHoneybadgerUser();
        break;
      case 'waiting':
      case 'identifying':
        break;
      default:
        assertNever(state);
    }
  };
}

export default CurrentHoneybadgerUserReactions;
